import { baseConfig } from './config';
import { csp } from './csp';
import { EnvConfig } from './environment.interface';

export const environment: EnvConfig = {
  ...baseConfig,
  name: 'prod.external',
  isInternal: false,
  isProduction: true,
  account_access_url: 'https://web-registration.vanguard.com/start',
  balances_url: 'https://balances.web.vanguard.com/',
  medallia_survey_url: 'https://mdl-medallia-digital.vanguard.com/pkg/1.0.0/web/external_libs/',
  medallia_surveys: {
    quit_inputpage: 447,
    quit_minor_inputpage: 2872,
    quit_gifting_inputpage: 3800,
    quit_internal_transfer_inputpage: 4019,
  },
  origin: 'https://personal.vanguard.com',
  pretty_ecs_domain: 'https://personal1.vanguard.com',
  fmfUrl: 'https://fmf-mr.esfp.c1.vanguard.com',
  v8url: 'https://n4v.web.vanguard.com/secure-site-components.js',
  cccConfig: {
    site: 'retailExternal',
    app: 'CWP',
    rte: 'prd',
    concerns: 'al,adl,it,cob,chat',
    appConfig: { csp },
  },
  cccServerlessJs:
    'https://mc3-static-assets.web.vanguard.com/vg-ccc-serverless/latest/vg-ccc-serverless.js',
  antiflickerJs: 'https://corp.at2.assets.vgdynamic.info/files/js/core/antiflicker-v2.min.js',
  vgimEnv: 'production',
  mfe: {
    'portfolio-builder-pkg': 'https://portfolio-builder.web.vanguard.com/portfolio-builder-pkg.js',
    'risk-quiz-pkg-roe': 'https://roe.web.vanguard.com/roe/risk-flow-pkg.js',
    'settlement-fund-pkg':
      'https://onb-mfe-settlement-fund.web.vanguard.com/onb-mfe-settlement-fund-element.js',
  },
  consumerApi: 'https://apps.ecs.retp.c1.vanguard.com/xs1-secure-site-consumer-api/adobe',
  logonUrl: 'https://logon.vanguard.com/logon',
  message_center_link: 'https://secure-messages.web.vanguard.com/',
  baseHref: '/cwp-change-of-ownership-angular/',
  applicationUrl: 'https://personal1.vanguard.com/cwp-change-of-ownership-angular',
  aemEnv: 'prod',
  dashboardLink: 'https://dashboard.web.vanguard.com',
};
